import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ModalContentProps {
  sticky?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Layout = styled.section<Partial<ModalContentProps>>`
  position: relative;
  flex-grow: 1;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;

  ${({ sticky }) =>
    sticky &&
    css`
      padding-bottom: ${toRem(theme.modal.footer.height)};
      overflow: auto;

      &:last-child {
        padding-bottom: ${toRem(theme.modal.spacing.large)};
      }
    `}
`;

const ModalContent: React.FC<ModalContentProps> = ({ sticky, children, className }) => (
  <Layout sticky={sticky} className={className} data-cy="modal-content">
    {children}
  </Layout>
);

export default ModalContent;
